import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Dictionary, IDictionary } from '../classes/dictionary';
import * as _ from 'underscore';

export class ValidationService {
	public static readonly GlobalValidation = new ValidationService();

	private isValidSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	public readonly isValid: Observable<boolean> = this.isValidSub.asObservable();
	private validators: IDictionary = new Dictionary([]);

	public resetValidation(): void {
		this.validators = new Dictionary([]);
		this.isValidSub.next(false);
	}
	/**
	 * Adds a new validator as a key/value pair in a new global dictionary of validators.
	 *
	 * @param {string} key Required ID of the Element to be validated
	 * @param {boolean} value Initial validator value
	 */
	add(key: string, value: boolean) {
		if (this.validators && !this.validators.containsKey(key)) {
			this.validators.add(key, value);
		} else if (this.validators.containsKey(key)) {
			this.validators.remove(key);
			this.validators.add(key, value);
		}
		this.validate();
	}

	/**
	 * Updates the validation value of the current Element
	 *
	 * @param {string} key Required ID of the Element to be validated
	 * @param {boolean} value Current validator value
	 */
	updateValue(key: string, value: boolean) {
		this.validators[key] = value;
		this.validate();
	}

	/**
	 * Clears the global validation list
	 */
	clearValidatorList() {
		var tempVal = new Dictionary([]);
		var keys = this.validators.keys();
		_.forEach(keys, (key) => {
			let value = this.validators[key];
			if (value) {
				tempVal.add(key, value);
			}
		});
		this.validators = tempVal;
		this.validate();
	}

	/**
	 * Removes a specific Element from the gloval validator list
	 *
	 * @param {string} id Required ID of the Element to be removed
	 */
	removeSpecific(id: string) {
		this.validators.remove(id);
		this.validate();
	}

	/**
	 * Gets the current validation value of a specific Element
	 *
	 * @param {string} id Required ID of the Element
	 */
	getValue(id: string): boolean {
		if (!this.validators.containsKey(id) || !this.validators[id]) return false;
		else return true;
	}

	/**
	 * Re-evaluate the global validator list
	 */
	private validate() {
		let values: any[] = [];
		this.validators.keys().forEach((key) => {
			values.push(this.validators[key]);
		});
		if (values.every((val) => val)) {
			setTimeout(() => {
				this.isValidSub.next(true);
			});
		} else {
			this.isValidSub.next(false);
		}
	}
}
